
import { useNavigate, useLocation } from 'react-router-dom';

interface NavItem {
  id: string;
  label: string;
  icon: string;
  path: string;
}

const navItems: NavItem[] = [
  { id: 'home', label: 'الرئيسية', icon: 'ri-home-4-fill', path: '/' },
  { id: 'services', label: 'الخدمات', icon: 'ri-hospital-fill', path: '/services' },
  { id: 'notifications', label: 'الإشعارات', icon: 'ri-notification-3-fill', path: '/notifications' },
  { id: 'profile', label: 'الملف الشخصي', icon: 'ri-user-3-fill', path: '/profile' }
];

export default function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-50">
      <div className="grid grid-cols-4 h-20">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-1 transition-all duration-200 ${
                isActive 
                  ? 'text-[#007AFF] bg-[#007AFF]/5' 
                  : 'text-[#7A7A7A] hover:text-[#007AFF]'
              }`}
            >
              <div className={`w-6 h-6 flex items-center justify-center ${isActive ? 'scale-110' : ''}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
